webpackJsonp([217130003604362],{

/***/ 522:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/our-mission-1.84dd9287.jpg";

/***/ }),

/***/ 523:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/our-mission-2.6278dad8.jpg";

/***/ }),

/***/ 524:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/our-mission-3.329aeb92.jpg";

/***/ }),

/***/ 525:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/our-mission__hero.c78e3bc9.jpg";

/***/ }),

/***/ 206:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(5);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _gatsbyLink = __webpack_require__(4);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Header = __webpack_require__(6);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _ourMission__hero = __webpack_require__(525);
	
	var _ourMission__hero2 = _interopRequireDefault(_ourMission__hero);
	
	var _ourMission = __webpack_require__(522);
	
	var _ourMission2 = _interopRequireDefault(_ourMission);
	
	var _ourMission3 = __webpack_require__(523);
	
	var _ourMission4 = _interopRequireDefault(_ourMission3);
	
	var _ourMission5 = __webpack_require__(524);
	
	var _ourMission6 = _interopRequireDefault(_ourMission5);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    _react.Fragment,
	    null,
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Our Mission | Who We Are'
	      // meta={[{ name: 'description', content: '' }]}
	    }),
	    _react2.default.createElement(
	      _Header2.default,
	      { hero: _ourMission__hero2.default },
	      _react2.default.createElement(
	        'h1',
	        { className: 't-hero' },
	        'Our Mission'
	      )
	    ),
	    _react2.default.createElement(
	      'main',
	      { id: 'content' },
	      _react2.default.createElement(
	        'div',
	        { className: 'c-golden t-context--light' },
	        _react2.default.createElement(
	          'div',
	          { className: 'c-golden__content c-golden__wide' },
	          _react2.default.createElement(
	            'ul',
	            { className: 'c-breadcrumbs mb30' },
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/' },
	                'Home'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/who-we-are' },
	                'Who We Are'
	              )
	            ),
	            _react2.default.createElement(
	              'li',
	              null,
	              _react2.default.createElement(
	                _gatsbyLink2.default,
	                { to: '/who-we-are/our-mission', activeClassName: 'is-active' },
	                'Our Mission'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-golden__text' },
	            _react2.default.createElement(
	              'div',
	              { className: 'c-golden__text-col' },
	              _react2.default.createElement(
	                'p',
	                { className: 't-p t-p--big t-p-light' },
	                'As a professional and dedicated team, we are committed to provide unsurpassed service at competitive rates; to be a leader in our industry; and to make a difference for a better world by helping others through our success.'
	              )
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'c-golden__next-page' },
	            _react2.default.createElement(
	              _gatsbyLink2.default,
	              { to: '/who-we-are/why-ati', className: 'c-btn t-link mt30' },
	              'Why ATI \xA0\u25B6'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'c-golden__images c-golden__short min-laptop' },
	          _react2.default.createElement(
	            'div',
	            { style: { width: '50%', height: '100%' } },
	            _react2.default.createElement('img', { src: _ourMission2.default, alt: '', style: { width: '100%', height: '50%' } }),
	            _react2.default.createElement('img', { src: _ourMission6.default, alt: '', style: { width: '100%', height: '50%' } })
	          ),
	          _react2.default.createElement('img', { src: _ourMission4.default, alt: '', style: { width: '50%', height: '100%' } })
	        )
	      )
	    )
	  );
	};
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-who-we-are-our-mission-js-3479a8ddabbf20b42d1c.js